module.exports = __webpack_public_path__ + "static/media/chat-icon.a5109d9c.svg";